import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../api.config";

export const probateCourtEventsApi = createApi({
  reducerPath: "probateCourtEventsApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["ProbateCourtEvent"],
  endpoints: (build) => ({
    getAllEvents: build.query({
      query: ({ caseId, eventType, status, startDate, endDate, page = 1, limit = 100 } = {}) => ({
        url: "/probate/court-events",
        method: "GET",
        params: { caseId, eventType, status, startDate, endDate, page, limit },
      }),
      providesTags: ["ProbateCourtEvent"],
    }),

    getEventById: build.query({
      query: (id) => ({ url: `/probate/court-events/${id}`, method: "GET" }),
      providesTags: (result, error, id) => [{ type: "ProbateCourtEvent", id }],
    }),

    getUpcomingEvents: build.query({
      query: (days = 30) => ({ url: "/probate/court-events/upcoming", method: "GET", params: { days } }),
      providesTags: ["ProbateCourtEvent"],
    }),

    getEventsForCase: build.query({
      query: (caseId) => ({ url: `/probate/court-events/case/${caseId}`, method: "GET" }),
      providesTags: ["ProbateCourtEvent"],
    }),

    createEvent: build.mutation({
      query: (event) => ({ url: "/probate/court-events", method: "POST", body: event }),
      invalidatesTags: ["ProbateCourtEvent"],
    }),

    updateEvent: build.mutation({
      query: ({ id, ...event }) => ({ url: `/probate/court-events/${id}`, method: "PUT", body: event }),
      invalidatesTags: (result, error, { id }) => [{ type: "ProbateCourtEvent", id }, "ProbateCourtEvent"],
    }),

    deleteEvent: build.mutation({
      query: (id) => ({ url: `/probate/court-events/${id}`, method: "DELETE" }),
      invalidatesTags: ["ProbateCourtEvent"],
    }),

    updateEventStatus: build.mutation({
      query: ({ id, status }) => ({ url: `/probate/court-events/${id}/status`, method: "PATCH", body: { status } }),
      invalidatesTags: (result, error, { id }) => [{ type: "ProbateCourtEvent", id }, "ProbateCourtEvent"],
    }),
  }),
});

export const {
  useGetAllEventsQuery,
  useGetEventByIdQuery,
  useGetUpcomingEventsQuery,
  useGetEventsForCaseQuery,
  useCreateEventMutation,
  useUpdateEventMutation,
  useDeleteEventMutation,
  useUpdateEventStatusMutation,
} = probateCourtEventsApi;
